import { TestImage } from "@assets/constant/index.constant";
import { Button } from "@components/ui/button";
import { GeneralCard, TableCard } from "@ui/internal/components/card";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuRadioGroup,
  DropdownMenuTrigger,
} from "@components/ui/dropdown-menu";
import { endpoint } from "@services/api.services";
import { usePathname } from "@utils/hook/index.hook";
import { QueryData } from "@utils/interface/index.interface";
import { CategoryData, DurationData } from "@utils/interface/journey.interface";
import { useListData } from "@utils/query/index.query";
import { useMetaStore } from "@utils/states/index.state";
import { format } from "date-fns";
import { NavLink, useNavigate, useParams, useSearchParams } from "react-router";
import {
  CategoryColumnList,
  DurationColumnList,
  BatchColumnList,
  CourseBatchColumnList,
} from "../column/index.column";
import CategoryForm from "../form/category.form";
import DurationForm from "../form/duration.form";
import BatchForm from "../form/batch.form";
import CoursesBatchForm from "../form/coursebatch";
import { ChevronLeft } from "lucide-react";

type Params = {
  setup: "categories" | "duration" | "batch" | "&-batch";
};
const index = () => {
  const pathname = usePathname();
  console.log("THIS IS THE PATHNAME", pathname);
  const { setup } = useParams<Params>();
  const [searchParams] = useSearchParams();
  const { search, date } = useMetaStore();
  const endpointValue =
    setup === "categories"
      ? endpoint["category"]
      : setup === "duration"
      ? endpoint["duration"]
      : setup === "batch"
      ? endpoint["batch"]
      : setup === "&-batch"
      ? endpoint["course-batch"]
      : "";
  /* ================================================= api calls logic ================================================= */
  const { data, isPending, refetch } = useListData<
    QueryData<CategoryData | DurationData>
  >({
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      search,
      created_date__gte: date.from ? format(date.from, "yyyy-MM-dd") : "",
      created_date__lte: date.to ? format(date.to, "yyyy-MM-dd") : "",
      ordering: searchParams.get("ordering") || "order",
      is_masterclass: pathname.startsWith("masterclass-courses") ? true : false,
      is_jrp: pathname == "jrp-courses-&-batch" ? true : false,
      section:
        searchParams
          .get("data-category")
          ?.toLocaleLowerCase()
          ?.split("-")[0] === "all"
          ? ""
          : searchParams
              .get("data-category")
              ?.toLocaleLowerCase()
              ?.split("-")[0] || "",
    },
    endpoint: endpointValue,
    key: `${pathname}-listing`,
    window: true,
  });

  const groupRefetch = () => {
    refetch();
  };

  const setupBasePath = pathname.startsWith("masterclass-courses")
    ? "/masterclass-courses"
    : "/courses";

  const columns =
    setup === "categories"
      ? CategoryColumnList()
      : setup === "duration"
      ? DurationColumnList()
      : setup === "batch"
      ? BatchColumnList()
      : setup === "&-batch"
      ? CourseBatchColumnList()
      : [];

  console.log(pathname);
  return (
    <>
      <TableCard
        bulkActions
        inject_ui_table_actions={
          <>
            {/* <Button variant={"outline"} onClick={() => navigate("/courses")}>
              <ChevronLeft /> Go Back
            </Button> */}
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="defaultoutline">Manage Setup</Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent className="w-56" align="start">
                <DropdownMenuRadioGroup>
                  <NavLink to={`${setupBasePath}/categories`}>
                    <DropdownMenuItem>Manage Categories</DropdownMenuItem>
                  </NavLink>

                  <NavLink to={`${setupBasePath}/duration`}>
                    <DropdownMenuItem>Manage Duration</DropdownMenuItem>
                  </NavLink>
                  <NavLink to={`${setupBasePath}/batch`}>
                    <DropdownMenuItem>Manage Batch</DropdownMenuItem>
                  </NavLink>
                  <NavLink to={`${setupBasePath}/&-batch`}>
                    <DropdownMenuItem>Manage Course & Batch</DropdownMenuItem>
                  </NavLink>
                </DropdownMenuRadioGroup>
              </DropdownMenuContent>
            </DropdownMenu>
          </>
        }
        table_content={{
          mode: "default",
          type: pathname,
        }}
        form={
          setup === "categories" ? (
            <CategoryForm />
          ) : setup === "duration" ? (
            <DurationForm />
          ) : setup === "batch" ? (
            <BatchForm />
          ) : setup === "&-batch" ? (
            <CoursesBatchForm />
          ) : (
            <> </>
          )
        }
        formId={pathname}
        // showOrientation
        orientationPosition={false}
        grid={
          <GeneralCard
            isChecked={false}
            type={"mentor"}
            content={{
              images: [TestImage, TestImage, TestImage],
              title: "Aayush Maharjan",
              subtitle: "Frontend Developer",
            }}
            onDelete={() => {}}
            onEdit={() => {}}
          />
        }
        columns={columns}
        refetch={groupRefetch}
        isPending={isPending}
        rows={data?.data?.results ?? []}
        endpoint={endpointValue}
        sortableFilter={{
          search: search,
          ordering: searchParams.get("ordering") || "order",
          section:
            searchParams
              .get("data-category")
              ?.toLocaleLowerCase()
              ?.split("-")[0] === "all"
              ? ""
              : searchParams
                  .get("data-category")
                  ?.toLocaleLowerCase()
                  ?.split("-")[0] || "",
        }}
        count={data?.data?.count ?? 10}
      />
    </>
  );
};

export default index;
